<template>
  <item-ferramenta-estudo>
    <section class="quiz">
      <div id="quiz" class="simulado-prova box-branco container quiz">
    <div class="row">
    <div class="thumb-sala" v-if="exibeOverlay" ref="quizOverlay">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-12 thumb-topico text-center mb-3 mb-md-3 mb-lg-4 mb-xl-5 d-flex justify-content-center" v-if="progresso < 100">
              <div class="col-6">
                <p>Você ainda não terminou todas as liçoes, tem certeza que deseja realizar o quiz?</p>
              </div>
            </div>
            <div class="col-12 text-center">
              <a class="btn btn-primary btn-comecar" v-on:click="comecarQuiz">Começar quiz!</a>
            </div>
          </div>
        </div>
      </div>
      <ListaQuestoes v-bind:questoes="questoes"></ListaQuestoes>
      <conteudo-questao v-bind:quiz-id="quizId" v-bind:questoes="questoes" v-bind:desempenho-quiz="desempenhoQuiz"></conteudo-questao>
      <desempenho v-bind:desempenho-quiz="desempenhoQuiz"></desempenho>
    </div>
    <div class="row" ref="proximoAnterior">
    <div class="col-12 btns-prev-next d-flex justify-content-between mt-5">
      <a v-on:click.prevent="questaoAnterior()"  class="btn btn-step" ><i class="fas fa-step-backward"></i> Anterior</a>
      <a v-on:click.prevent="proximaQuestao()" class="btn btn-step">Próximo <i class="fas fa-step-forward"></i></a>
    </div>
    </div>
  </div>
  </section>
  </item-ferramenta-estudo>
</template>

<script>
import ItemFerramentaEstudo from '../ItemFerramentaEstudo'
import SimuladoAPI from '@/api/simulado-api'
import ListaQuestoes from '@/modules/SalaAula/components/ferramenta-estudo/items/quiz/ListaQuestoes'
import ConteudoQuestao from '@/modules/SalaAula/components/ferramenta-estudo/items/quiz/ConteudoQuestao'
import Desempenho from '@/modules/SalaAula/components/ferramenta-estudo/items/quiz/Desempenho'

export default {
  name: 'Quiz',
  components: { ListaQuestoes, ConteudoQuestao, Desempenho, ItemFerramentaEstudo },
  props: {
    quiz: Object,
    curso: Object
  },
  data () {
    return {
      questoes: this.quiz.questoes,
      modeloId: this.quiz.idSimulado,
      progresso: this.curso.progresso,
      quizId: 0,
      desempenhoQuiz: {
        questoes_acertadas: 0,
        questoes_incorretas: 0,
        questoes_sem_resposta: 0
      },
      exibeOverlay: true,
      ordem: 1,
      quantidadeQuestoes: 0
    }
  },
  mounted () {
    window.eventBus.$on('selecionaQuestao', (data) => {
      this.ordem = data.ordem
    })
    this.quantidadeQuestoes = this.questoes.length
  },
  watch: {
    carregado: function () {
      this.$refs.quizOverlay.style.display = 'table'
    },
    quiz: function () {
      this.questoes = this.quiz.questoes
      this.modeloId = this.quiz.idSimulado
      this.progresso = this.curso.progresso
      this.exibeOverlay = true
      this.quantidadeQuestoes = this.questoes.length
    }
  },
  methods: {
    comecarQuiz: async function () {
      let response = await SimuladoAPI.comecarQuiz(this.modeloId)
      this.questoes = response.quiz.questoes
      this.quizId = response.quiz.id
      this.desempenhoQuiz = response.quiz.desempenho
      this.exibeOverlay = false
      window.eventBus.$emit('selecionaQuestao', this.questoes[0])
    },
    possuiQuestaoAnterior: function () {
      return this.questoes.length && this.ordem > this.questoes[0].ordem
    },

    possuiProximaQuestao: function () {
      return this.ordem < this.quantidadeQuestoes
    },
    questaoAnterior: function () {
      if (this.possuiQuestaoAnterior()) {
        this.selecionaQuestao(this.questoes[this.questoes.findIndex(item => item.ordem === this.ordem) - 1])
      }
    },
    proximaQuestao: function () {
      if (this.possuiProximaQuestao()) {
        this.selecionaQuestao(this.questoes[this.questoes.findIndex(item => item.ordem === this.ordem) + 1])
      }
    },
    selecionaQuestao (questao) {
      this.ordem = questao.ordem
      window.eventBus.$emit('selecionaQuestao', questao)
    }
  }
}
</script>

<style scoped>
</style>
